export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden pt-16">
      <div className="absolute inset-0 -z-10">
        <img
          src="https://readdy.ai/api/search-image?query=soft%20kawaii%20healing%20manga%20scene%20with%20a%20fluffy%20orange%20cat%20mascot%20among%20floating%20pastel%20pink%20cream%20and%20peach%20blossoms%20and%20paw%20prints%2C%20warm%20dreamy%20anime%20background%20art%2C%20gentle%20light%2C%20wholesome%20cozy%20atmosphere%2C%20soft%20blurred%20pastel%20gradient&width=1600&height=900&seq=hero-main&orientation=landscape"
          alt="皮皮喵漫画软萌治愈画风背景插画"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/40 to-background-50"></div>
      </div>

      <div className="mx-auto flex w-full max-w-7xl flex-col items-center px-4 py-20 text-center md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/90 px-4 py-1.5 text-sm font-medium text-primary-700 ring-1 ring-primary-200">
          <i className="ri-heart-3-line"></i>
          每天更新治愈向作品，追更不迷路
        </span>

        <h1 className="mt-6 max-w-3xl font-heading text-4xl leading-tight text-foreground-950 md:text-5xl">
          皮皮喵漫画
          <span className="mt-2 block text-primary-600">
            萌系推荐与治愈系漫画清单
          </span>
        </h1>

        <p className="mt-6 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          软萌画风、温馨剧情、可爱角色一网打尽。无论你想找治愈系漫画清单，
          还是迷上某个软萌角色合集，这里都能帮你快速定位心仪的作品。
        </p>

        <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:gap-4">
          <a
            href="#featured"
            className="whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-base font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            开始探索萌系漫画
          </a>
          <a
            href="#healing"
            className="whitespace-nowrap rounded-full bg-background-50/90 px-7 py-3 text-base font-bold text-primary-700 ring-1 ring-primary-300 transition-colors hover:bg-primary-100"
          >
            查看治愈清单
          </a>
        </div>

        <div className="mt-14 grid w-full grid-cols-2 gap-4 sm:grid-cols-4">
          {[
            { value: "1200+", label: "治愈系作品" },
            { value: "36 个", label: "软萌画风标签" },
            { value: "每周 3 期", label: "更新推荐" },
            { value: "98%", label: "读者好评" },
          ].map((stat) => (
            <div
              key={stat.label}
              className="rounded-xl bg-background-50/85 px-4 py-5 text-center ring-1 ring-background-200"
            >
              <div className="font-heading text-2xl text-primary-600 md:text-3xl">
                {stat.value}
              </div>
              <div className="mt-1 text-sm text-foreground-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}